<template>
  <div
    class="max-w-7xl mx-auto border border-black p-6 text-sm font-sans space-y-2"
  >
    <!-- Header -->
    <div class="grid grid-cols-3 gap-6 border-black">
      <div>
        <!-- <pre>{{ dataDetail }}</pre> -->
        <p class="font-bold mb-2">*Kantor Pengirim</p>
        <p v-if="dataDetail">
          {{ dataDetail.sender.zipCode + " - " + dataDetail.origin.name }}
        </p>

        <p>Jenis Customer: <span class="font-medium">Corporate</span></p>
       
      </div>
      <!-- Outlet & Jenis -->
      <div>
        <p class="text-lg font-bold uppercase">Consignment Note</p>
        <div class="mt-2">
          <p>
            Outlet Asal:
            <span class="font-medium"
              >{{ dataDetail.origin.name }} ({{
                dataDetail.origin.phoneNumber
              }})</span
            >
          </p>
        </div>
        <div>
          <p>
            Outlet Tujuan:
            <span class="font-medium"
              >{{ dataDetail.destination.name }} ({{
                dataDetail.destination.phoneNumber
              }})</span
            >
          </p>
        </div>
        <div>
          <p>Jenis Layanan: <span class="font-medium">HUB TO HUB</span></p>
        </div>
      </div>
      <div class="text-center space-y-1">
        <img src="@/assets/logo-kai.svg" alt="KAI Logo" class="w-14 mx-auto" />
        <div class="flex items-center justify-center">
          <svg id="barcode" v-if="dataDetail"></svg>
        </div>
      </div>
    </div>

    <!-- Pengirim & Penerima -->
    <div class="grid grid-cols-3 gap-6 border-t-2 border-black pt-3 mt-3">
      <div class="space-y-2">
        <p class="font-bold">Pengirim</p>
        <p>Nama: {{ dataDetail.sender.name }}</p>
        <p>Alamat: {{ dataDetail.sender.address }}</p>
        <p>Telp: {{ dataDetail.sender.phoneNumber }}</p>
      </div>
      <div class="space-y-2">
        <p class="font-bold">Penerima</p>
        <p>Nama: {{ dataDetail.recipient.name }}</p>
        <p>Alamat: {{ dataDetail.recipient.address }}</p>
        <p>Telp: {{ dataDetail.recipient.phoneNumber }}</p>
      </div>
      <div class="space-y-2">
        <p class="font-bold">
          {{ dataDetail.trackingCode }}
        </p>
        <p>Tanggal Transaksi: {{ formatDate(dataDetail.createdAt) }}</p>
        <p>Keterangan: {{ dataDetail.descriptions }}</p>
      </div>
    </div>

    <!-- Detail Pengiriman -->
    <div class="border-t-2 border-black mt-3 pt-2">
      <table class="w-full border-separate border-spacing-y-1">
        <thead>
          <tr class="text-sm text-left">
            <th class="border-none">ISI BARANG</th>
            <th class="border-none text-center">KOLI</th>
            <th class="border-none text-center">BERAT (KG)</th>
            <th class="border-none text-center">PICKUP</th>
            <th class="border-none text-center">DOORING</th>
            <th class="border-none text-center">PACKING</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-sm">
            <td class="border-none">PAKET</td>
            <td class="border-none text-center">{{ dataDetail.koli }}</td>
            <td class="border-none text-center">{{ dataDetail.weight }}</td>
            <td class="border-none text-center">0</td>
            <td class="border-none text-center">0</td>
            <td class="border-none text-center">0</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Keterangan -->

    <!-- Footer -->
    <div class="flex justify-between mt-6">
      <div>
        <p>Tanggal Cetak {{ formatDate(new Date()) }}</p>
      </div>
    </div>

    <!-- Tanda tangan -->
    <div class="grid grid-cols-3 gap-4 text-center mt-6 text-xs">
      <div>
        <p>Petugas</p>
        <div class="mt-6 border-t border-black pt-1">Agus Eming</div>
      </div>
      <div>
        <p>Pengirim</p>
        <div class="mt-6 border-t border-black pt-1">
          (...........................)
        </div>
      </div>
      <div>
        <p>Penerima</p>
        <div class="mt-6 border-t border-black pt-1">
          (...........................)
        </div>
      </div>
    </div>

    <p class="text-xs font-semibold mt-6 text-justify">
      Pernyataan Pengirim:
    </p>
    <p class="text-xs mt-6 text-justify">
      Dengan ini telah menyatakan mengerti dan menerima Ketentuan dan
      Syarat-syarat Pengiriman yang tercantum dalam Consignment-Note ini.
    </p>
   <p class="text-xs font-semibold mt-6 text-justify">
      List Transaksi:
    </p>
    <p class="text-xs mt-6 text-justify">{{ dataDetail.transactions.join(',') }}</p>
  </div>
</template>

<script>
export default {
  name: "PrintKalog",
  data() {
    return {
      isMounted: false,
      dataDetail: null,
    };
  },
  methods: {
    generateBarcode(value) {
      let JsBarcode = require("jsbarcode");
      window.setTimeout(function() {
        JsBarcode("#barcode", value);
      }, 0);
    },
    formatDate(value) {
      let options = { year: "numeric", month: "long", day: "numeric" };
      let date = new Date(value).toLocaleString("id-ID", options);
      return date;
    },
    formatToDDMMYY(datetime) {
      const date = new Date(datetime);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(2); // ambil 2 digit terakhir
      return `${day}${month}${year}`;
    },
  },
  mounted() {
    const itemData = sessionStorage.getItem("printItem");
    if (itemData) {
      this.dataDetail = JSON.parse(itemData);
      this.$nextTick(() => {
        // Tunggu DOM selesai render
        this.generateBarcode(this.dataDetail.trackingCode);

        setTimeout(() => {
          window.print();
        }, 500);
      });
    }
  },
};
</script>

<style scoped>
svg#barcode {
  width: 150px;
  height: 50px;
}
</style>
